import {
    Box
} from "@pankod/refine-mui";
import { useSearchParams } from "@pankod/refine-react-router-v6";
import { CONST } from "config/const";
import { useLayoutOffFlag } from "hooks/useLayoutOffFlag";

export const Footer: React.FC = () => {
    const isLayoutOff = useLayoutOffFlag();;

    if (isLayoutOff) {
        return <></>;
    }
    
    return (
        <Box sx={{
            height: "64px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: {
                xs: "12px",
                md: "14px"
            }
        }}>
            Welcome to streamer studio
        </Box>
    );
};
